import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { Partner } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PartnerStoreService {
  private readonly _partner$ = new BehaviorSubject<Partner | null>(null);

  public partner$: Observable<Partner | null> = this._partner$.asObservable();

  public setPartner(partner: Partner): void {
    this._partner$.next(partner);
  }

  public resetStore(): void {
    this._partner$.next(null);
  }
}
